export const retskredse = [
  { id: 99, kode: "0", navn: "Udenfor retskreds" },
  { id: 23, kode: "1134", navn: "Københavns Byret" },
  { id: 22, kode: "1101", navn: "Retten på Frederiksberg" },
  { id: 20, kode: "1102", navn: "Retten i Lyngby" },
  { id: 21, kode: "1109", navn: "Retten i Glostrup" },
  { id: 19, kode: "1104", navn: "Retten i Helsingør" },
  { id: 18, kode: "1113", navn: "Retten i Hillerød" },
  { id: 17, kode: "1115", navn: "Retten i Roskilde" },
  { id: 16, kode: "1118", navn: "Retten i Holbæk" },
  { id: 15, kode: "1122", navn: "Retten i Næstved" },
  { id: 14, kode: "1129", navn: "Retten i Nykøbing Falster" },
  { id: 24, kode: "1131", navn: "Retten på Bornholm" },
  { id: 12, kode: "1137", navn: "Retten i Odense" },
  { id: 13, kode: "1135", navn: "Retten i Svendborg" },
  { id: 11, kode: "1147", navn: "Retten i Sønderborg" },
  { id: 10, kode: "1151", navn: "Retten i Esbjerg" },
  { id: 9, kode: "1155", navn: "Retten i Kolding" },
  { id: 8, kode: "1157", navn: "Retten i Horsens" },
  { id: 7, kode: "1159", navn: "Retten i Herning" },
  { id: 6, kode: "1162", navn: "Retten i Holstebro" },
  { id: 4, kode: "1171", navn: "Retten i Århus" },
  { id: 3, kode: "1165", navn: "Retten i Randers" },
  { id: 5, kode: "1169", navn: "Retten i Viborg" },
  { id: 2, kode: "1178", navn: "Retten i Aalborg" },
  { id: 1, kode: "1183", navn: "Retten i Hjørring" },
];
